/**
 * Safely checks if a string contains another string, ignoring case.
 * Returns false if either argument is null/undefined.
 *
 * @param {string} string - The string to search within
 * @param {string} search - The string to search for
 * @returns {boolean} True if the search string is found within the main string (case insensitive)
 *
 * @example
 * containsTextCaseInsensitive("Hello World", "world") // returns true
 * containsTextCaseInsensitive("Hello World", "xyz") // returns false
 * containsTextCaseInsensitive(null, "test") // returns false
 */
const containsTextCaseInsensitive = (string, search) => {
  if (!string || !search) {
    return false;
  }
  return string.toLowerCase().includes(search.toLowerCase());
};

export { containsTextCaseInsensitive };
